package horcrux.common.api.dtos.types

import horcrux.common.ValidatedValueClass
import horcrux.common.api.dtos.DocumentChunkerType
import horcrux.common.api.dtos.EmbeddingModelID
import horcrux.common.extensions.product
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@JvmInline
@Serializable
value class DocumentChunkSchemaVersion(override val value: Int) : ValidatedValueClass<Int, DocumentChunkSchemaVersion> {
    companion object {
        val ZERO: DocumentChunkSchemaVersion = DocumentChunkSchemaVersion(0)
        val ONE: DocumentChunkSchemaVersion = DocumentChunkSchemaVersion(1)
    }
}

@Serializable
data class DocumentMetadata(
    val originalCollectionID: CollectionID,
    val collectionID: CollectionID,
    val documentID: DocumentID,
    val createdAt: Instant,
    val documentURL: DocumentURL,
    val numChunks: NumChunks,
    val documentType: DocumentType,
    val documentName: DocumentName,
    val getSignedDocumentURL: DocumentURL,
    val privacyType: DocumentPrivacyType,
    val embeddingModelID: EmbeddingModelID,
    val documentRelationshipTypeByID: Map<DocumentID, DocumentRelationshipType>,
    val documentChunkSchemaVersion: DocumentChunkSchemaVersion,
    val documentChunkerType: DocumentChunkerType,
    val rawDocumentID: RawDocumentID
) {
    val isRootDocument: Boolean
        get() = documentRelationshipTypeByID[documentID] == DocumentRelationshipType.ROOT

    companion object {
        val List<DocumentMetadata>.documentMetadataListByParentID: Map<DocumentID, List<DocumentMetadata>>
            get() = this.product(this).filter { p ->
                val documentMetadata1 = p.first
                val documentMetadata2 = p.second
                documentMetadata2.documentRelationshipTypeByID[documentMetadata1.documentID] in listOf(
                    DocumentRelationshipType.CHILD, DocumentRelationshipType.ASSOCIATE
                )
            }.groupBy({ it.first.documentID }) { it.second }
    }
}

